import actions from './actions';

export default {
  state: {
    route: {},
    currentSectionName: '',
    menu: {
      opened: false,
      activeLocation: 0,
    },
    clickedFromMenu: false,
  },
  getters: {
    logo: state => {
      const whiteLogoPages = ['home', 'products'];
      if (state.menu.opened || whiteLogoPages.includes(state.currentSectionName))
        return {
          name: 'white',
          class: 'logo--white',
          src: require('@/assets/images/logo-white.png'),
        };
      return {
        name: 'black',
        class: 'logo--black',
        src: require('@/assets/images/logo-black.png'),
      };
    },
    showContactUs: state => {
      const showContactPages = ['home', 'vision', 'products', 'team', 'values', 'careers'];
      return showContactPages.includes(state.currentSectionName) && !state.menu.opened
        ? true
        : false;
    },
    showMenu: state => {
      const showMenuPages = [
        'home',
        'vision',
        'products',
        'team',
        'values',
        'careers',
        'job-apply',
        'contact',
      ];
      return showMenuPages.includes(state.currentSectionName) ? true : false;
    },
    showIndicator: state => {
      const indexedPages = ['home', 'vision', 'products', 'team', 'values', 'careers'];
      return indexedPages.includes(state.currentSectionName) && !state.menu.opened ? true : false;
    },
    menuOpened: state => state.menu.opened,
    activeLocation: state => state.menu.activeLocation,
    pagingUp: state => state.route.to.meta.pageIndex < state.route.from.meta.pageIndex,
    pagingDown: state => state.route.to.meta.pageIndex > state.route.from.meta.pageIndex,
    menuClicked: state => state.clickedFromMenu,
    currentSection: state => state.currentSectionName,
  },
  mutations: {
    updateRoute: (state, { to, from }) => {
      state.route = { to, from };
    },
    openMenu: state => {
      state.menu.opened = true;
    },
    closeMenu: state => {
      state.menu.opened = false;
    },
    updateActiveLocation: state => {
      state.menu.activeLocation = (state.menu.activeLocation + 1) % 3;
    },
    setActiveLocationTo: (state, index) => {
      state.menu.activeLocation = index;
    },
    resetClickedFromMenu: state => {
      state.clickedFromMenu = false;
    },
    triggerClickedFromMenu: state => {
      state.clickedFromMenu = true;
    },
    changeSectionName: (state, name) => {
      state.currentSectionName = name;
    },
  },
  actions,
};
